import React from 'react';
import { withStyles } from '@mui/styles';
import { connect } from 'react-redux';
import produce from 'immer';

import InfiniteScroll from "react-infinite-scroll-component";

import { Divider, Tabs, Tab, Table, TableRow, TableCell, TableHead, TableBody } from '@mui/material';

import LoaderNew from '../../common/LoaderNew';
import CommonStyles from '../../common/CommonStyles';
import ComponentWrapper from '../../common/ComponentWrapper';
import PersonalInviteTab from './components/PersonalInviteTab';
import PublicInviteTab from './components/PublicInviteTab';
import Node from '../../common/Node';

import moment from 'moment';

import AccountRow from './components/AccountRow';

import { getLastRstData, isObjectPredicate, removeUrlParameter, setUrlParameter, getUrlParameter } from '../../utils';

const styles = {
  loaderContainer: {
    display: 'flex',
    marginTop: '60px',
    justifyContent: 'center',
  },
  inviteContainer: {
    background: '#fff',
    padding: '20px 30px 10px 30px',
  },
  tableCell: {
    padding: '0px 5px 0px 5px !important',
  },
  tdPurple: {
    background: '#DBD6E5 !important',
  },
  inviteBtn: {
    textTransform: 'none !important',
  },
  selected: {
    border: '1px solid #347CFF',
  },
  passwordText: {
    fontSize: 12,
    color: '#878787',
  },
  passwordValue: {
    fontSize: 12,
    color: '#4E4C4C',
  },
  typeCheckbox: {
    margin: '2px 2px 5px 2px',
    padding: '1px',
    alignItems: 'start',
    justifyContent: 'center',
    '& .MuiSvgIcon-root': {
      width: '14px',
      height: '14px',
      color: '#222029',
    },
    '& .Mui-checked .MuiSvgIcon-root': {
      color: '#222029',
    },
    '& .MuiButtonBase-root': {
      padding: '0',
    },
  },
  ...CommonStyles,
  // table: {
  //   width: 'auto',
  //   color: '#4E4C4C',
  //   marginBottom: 80,
  // },
};

export const ACCOUNTS = "accounts";
export const PRIVATE = "private";
export const PUBLIC = "public";

export const activeAcc = '#1EB923';
export const inactiveAcc = '#E74C3C';

class AccountsPage extends ComponentWrapper {
  state = {
    accs: [],
    items: 20,
    nodesData: {},
    loaded: false,
    accounts: [],
    accountsTbox: {},
    setupAncestors: [],
    accsToShowFilters: {},
    currentTab: ACCOUNTS,
    invites: [],
    privateInvites: [],
    publicInvites: [],
    allSetupAccounts: [],
  };

  componentDidMount() {
    document.title = "Accounts | Milkyweb";

    const currentTab = getUrlParameter('tab');
    if (currentTab) this.setState({ currentTab });

    this.getInvitations();

    this.get({
      url: '/meta_query?meta_query=["setup_accounts", "setup_accounts_tbox"]',
      cb: (res) => {
        if (res) {
          const { setup_accounts, setup_accounts_tbox } = res._meta_query;

          this.getAccounts(setup_accounts, setup_accounts_tbox);
        }
      },
      disableNotify: true,
    });
  };

  getAccounts = (setup_accounts, setup_accounts_tbox) => {
    const accounts = setup_accounts || {};
    const accountsTbox = setup_accounts_tbox.nodes || {};
    const setupAncestors = setup_accounts_tbox.implemented_cids || [];

    let allSetupAccounts = [];

    getAllSetupRoles(setupAncestors);

    function getAllSetupRoles(setupAncestors) {
      if (setupAncestors && Array.isArray(setupAncestors) && Object.values(accountsTbox).length) {
        setupAncestors.forEach(acc => {
          if (!allSetupAccounts.includes(acc))allSetupAccounts.push(acc);
          let roles = (accountsTbox && accountsTbox[acc] && accountsTbox[acc].box && accountsTbox[acc].box.t_subs) ? accountsTbox[acc].box.t_subs : [];
          allSetupAccounts = [...allSetupAccounts, ...roles];
          if (roles.length) getAllSetupRoles(roles);
        })
      }
    }

    const accsToShowFilters = Object.keys(accountsTbox).reduce((filter, acc) => {
      return filter = {...filter, [acc]: { active: true, inactive: true, all: true }};
    }, {});

    this.setState({ accounts, allSetupAccounts, setupAncestors, accountsTbox, accsToShowFilters, loaded: true }, () => {
      this.collectAccountsByFilter();
    });
  };

  onAccountTypeChange = (accountId, value) => {
    const accounts = { ...this.state.accounts };
    const accountCopy = { ...accounts[accountId] };

    this.postWithData({
      url: `/rest/upd_acc`,
      data: {
        op: 'right',
        accid: accountId,
        right: value,
      },
    });

    accountCopy.access_level = value;

    accounts[accountId] = accountCopy;

    this.setState({ accounts });
  };

  onEnableInvite = (invite, value, index) => {

    this.postWithData({
      url: `/rest/enable_invitation`,
      data: {
        id: invite.id,
        enabled: value,
      },
      cb: (data) => {
        if (data.status === 'error') {
          console.log(data);
        } else {
          this.getInvitations();
        }
      },
    });
  };

  deleteInvitation = (invite, index) => {

    this.postWithData({
      url: ` /rest/delete_invitation`,
      data: {
        id: invite.id,
      },
      cb: (data) => {
        if (data.status === 'error') {
          console.log(data);
        } else {
          this.getInvitations();
        }
      },
    });
  };

  getInvitations = () => {
    this.get({
      url: `/rest/get_invitations`,
      cb: (data) => {
        if (data.status === 'error') {
          console.log(data);
        } else {
          this.sortInvites(data);

          this.collectNodeIdsFromGraphTriggers(data);
          
          this.setState({
            invites: data,
          });
        }
      },
    })
  };

  sortInvites = (data) => {
    let privateInvites = [];
    let publicInvites = [];

    data.forEach(invite => {
      if (invite.is_private) {
        privateInvites.push(invite);
      } else {
        publicInvites.push(invite);
      }
    });

    privateInvites.sort((a, b) => moment(b.time) - moment(a.time));
    publicInvites.sort((a, b) => moment(b.time) - moment(a.time));
    
    this.setState({
      privateInvites,
      publicInvites,
    });
  };

  collectAccountsByFilter = () => {
    const { accounts, accsToShowFilters } = this.state;

    const accs = accounts && Object.keys(accounts).reduce((arr, accountId) => {
      const account = accounts[accountId];
    
      if (account.individual && account.individual.box && account.individual.box.a_bottom) {
        let toShow = false
        account.individual.box.a_bottom.forEach(concept => {
          if (
            accsToShowFilters[concept] &&
            (accsToShowFilters[concept].all === true ||
              (accsToShowFilters[concept].active === true && account.access_level !== -1) ||
              (accsToShowFilters[concept].inactive === true && account.access_level === -1))
          ) toShow = true;
        });

        if (toShow) arr.push(account);
      }
    
      return arr;
    }, []);

    this.setState({ accs });
  };

  fetchMoreData = () => {
    this.setState({ items: this.state.items + 20 });
  };

  getAccsChunk = () => {
    const { items, accs } = this.state;

    if (!accs || !accs.length) return [];

    return accs.slice(0, items);
  };

  // we need a single source of data to avoid this shit
  addNodeToNodesData = (node) => {
    this.setState({ nodesData: { ...this.state.nodesData, [node.id]: node } })
  };

  collectNodeIdsFromGraphTriggers = (accessRules) => {
    const { setup_rbox_light } = this.props.light_meta_and_ops;
    const { setup } = this.props;

    const nodesIds = this.getNodesIdsFromPreState(accessRules, setup_rbox_light);

    const data = {
      api_key: setup.id,
      nesting: 2,
      filter: {
        nodes: nodesIds,
        page: 1,
        limit: 100,
      },
      sorter: {
        sort_pid: '',
        sort_by: '',
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data,
      cb: (data) => {
        if (data.nodes) this.setState({ nodesData: data.nodes });
      }
    });
  };

  getNodesIdsFromPreState = (currentItemsArray, setup_rbox_light) => {
    const nodes = [];
    for (let item of currentItemsArray) {
      const filter = item.pre_state;
      if (filter && filter.length) {
        if (item.role && nodes.indexOf(+item.role) === -1) nodes.push(+item.role);
        for (let row of filter) {
          const rst = getLastRstData(row.pids_chain, item.role, setup_rbox_light);
          if (rst && isObjectPredicate(rst) && +row.val && nodes.indexOf(+row.val) === -1) nodes.push(+row.val);
        }
      }
    }
    return nodes;
  };

  createInvite = (role, email, filter, cb) => {
    let reqData = {};
    if (email) reqData.email = email;
    if (filter && filter.length) reqData.pre_state = filter;
    if (role) reqData.role = role.id;
    
    this.setState({ inviteIsLoaded: false }, () => {
      this.postWithData({
        url: `/rest/request_invite`,
        data: reqData,
        cb: (data) => {
          if (data.status === 'error') {
            this.setState({
            });
          } else {
            this.getInvitations();
            
            if (cb) cb(data.status)
          }
        },
        errorCb: () => {
          this.setState({
          });
        },
      });
    });
  };

  sendInvitation = (code) => {
    this.postWithData({
      url: `/rest/send_invite`,
      data: {
        hash: code,
      },
      cb: (data) => {
        if (data.status === 'error') {
        } else {
          this.getInvitations();
        }
      },
      errorCb: () => {
        this.setState({
        });
      },
    });
  };

  statusFilterChange = (status, accConcept, value) => {
    const { accsToShowFilters } = this.state;

    const immutableFilters = produce(accsToShowFilters, mutableFilters => {
      const mutableAccConcept = mutableFilters[accConcept];
      if (status === 'all') {
        mutableAccConcept[status] = value;
        mutableAccConcept.active = value;
        mutableAccConcept.inactive = value;
      } else {
        if (value === false) {
          mutableAccConcept.all = value;
        }
        mutableAccConcept[status] = value;
      }
      if (mutableAccConcept.active === true && mutableAccConcept.inactive === true) mutableAccConcept.all = true;
    });

    this.setState({ accsToShowFilters: immutableFilters }, () => {
      this.collectAccountsByFilter();
    });
  };

  changeAllFilters = (key, value) => {
    const immutableFilters = produce(this.state.accsToShowFilters, mutableFilters => {
      Object.values(mutableFilters).forEach(conceptFilter => {
        if (key === 'all') {
        conceptFilter.all = value;
        conceptFilter.active = value;
        conceptFilter.inactive = value;
        } else {
          conceptFilter[key] = value;
          if (conceptFilter[key === 'active' ? 'inactive' : 'active'] !== value) conceptFilter.all = false;
          else if (value === true) conceptFilter.all = true;
        }
      });
    });

    this.setState({ accsToShowFilters: immutableFilters }, () => {
      this.collectAccountsByFilter();
    });
  };

  render() {
    const {
      accs,
      items,
      loaded,
      accounts,
      nodesData,
      currentTab,
      setupAncestors,
      accountsTbox,
      privateInvites,
      publicInvites,
      accsToShowFilters,
      allSetupAccounts,
    } = this.state;

    const { classes } = this.props;

    const accountsSummary = Object.values(accounts).reduce((accsTotalObj, account) => {
      if (account.access_level !== -1) accsTotalObj.active++;
      else accsTotalObj.inactive++;
      return accsTotalObj;
    }, { active: 0, inactive: 0 });

    const allFiltersSelected = Object.values(accsToShowFilters).some(filter => filter.all === false) ? false : true;
    const activeFiltersSelected = Object.values(accsToShowFilters).some(filter => filter.active === false) ? false : true;
    const inactiveFiltersSelected = Object.values(accsToShowFilters).some(filter => filter.inactive === false) ? false : true;

    const accsChunk = this.getAccsChunk();
    let hasMoreData = accs && accs.length ? accs.length > accsChunk.length : false;

    return (
      <div>
        <div className={classes.tabsContainer} style={{ marginBottom: '1px' }}>
          <Tabs
            className={classes.tabs}
            value={this.state.currentTab}
            onChange={(event, newTab) => {
              if (newTab === ACCOUNTS) {
                removeUrlParameter('tab');
              } else setUrlParameter('tab', newTab);
              this.setState({ currentTab: newTab, items: 20 })
            }}
          >
            <Tab value={ACCOUNTS} label='Accounts' />
            <Tab value={PRIVATE} label='Private email invitation' />
            <Tab value={PUBLIC} label='Public link invitation' />
          </Tabs>

          <Divider light />
        </div>

        <div>
          {loaded && currentTab === ACCOUNTS ? (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                margin: '10px 50px',
              }}
            >
              {Object.keys(accountsTbox).length && Object.keys(accsToShowFilters).length ?
                <Table
                  className={`${classes.table} ${classes.mr30}`}
                  style={{
                    position: 'relative',
                    width: 'fit-content',
                    height: 'fit-content',
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell className={`${classes.columnHeadingGeneral}`}>
                        <div className={classes.alignStartColumn}>
                          Group
                        </div>
                      </TableCell>
                      <TableCell
                        className={`${classes.columnHeadingGeneral} `}
                      >
                        <div className={classes.alignStartColumn}>
                          Total
                        </div>
                      </TableCell>
                      <TableCell className={`${classes.columnHeadingGeneral}`}>
                        <div className={classes.alignStartColumn} style={{ color: activeAcc }}>
                          Active
                        </div>
                      </TableCell>
                      <TableCell className={`${classes.columnHeadingGeneral}`}>
                        <div className={classes.alignStartColumn} style={{ color: inactiveAcc }}>
                          Inactive
                        </div>
                      </TableCell>
                    </TableRow>

                    <TableRow className={`${classes.tableRow}`}>
                      <TableCell className={`${classes.columnHeadingGeneral}`}>
                        <div className={classes.alignStartColumn}>
                          <span>{Object.keys(accountsTbox).length}</span>
                        </div>
                      </TableCell>
                      <TableCell
                        className={`${classes.columnHeadingGeneral} `}
                      >
                        <div
                          className={`${classes.actionIcon} ${allFiltersSelected ? 'selected' : ''}`}
                          onClick={() => this.changeAllFilters('all', !allFiltersSelected)}
                        >
                          <span>{Object.keys(accounts).length}</span>
                        </div>
                      </TableCell>
                      <TableCell className={`${classes.columnHeadingGeneral}`}>
                        <div
                          className={`${classes.actionIcon} ${activeFiltersSelected ? 'selected' : ''}`}
                          onClick={() => this.changeAllFilters('active', !activeFiltersSelected)}
                        >
                          {accountsSummary.active ?
                            <span style={{ color: activeAcc }}>{accountsSummary.active}</span>
                          : null}
                        </div>
                      </TableCell>
                      <TableCell className={`${classes.columnHeadingGeneral}`}>
                        <div
                          className={`${classes.actionIcon} ${inactiveFiltersSelected ? 'selected' : ''}`}
                          onClick={() => this.changeAllFilters('inactive', !inactiveFiltersSelected)}
                        >
                          {accountsSummary.inactive !== 0 ?
                            <span style={{ color: inactiveAcc }}>{accountsSummary.inactive}</span>
                          : null}
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody style={{ backgroundColor: 'transparent' }}>
                    {Object.values(accountsTbox).map((accountType, index) => {
                      const allAccsByAccType = accounts && Object.values(accounts)
                        .filter(account => account.individual && account.individual.box && account.individual.box.a_bottom
                          && account.individual.box.a_bottom.includes(Number(accountType.id)));
                      const inactiveAccs = allAccsByAccType && allAccsByAccType.filter(account => account.access_level === -1);
                      const activeAccs = allAccsByAccType && allAccsByAccType.filter(account => account.access_level !== -1);

                      let allSelected = accsToShowFilters[accountType.id].all === true;
                      const activeSelected = accsToShowFilters[accountType.id].active === true;
                      const inactiveSelected = accsToShowFilters[accountType.id].inactive === true;

                      return (
                      <TableRow
                        key={accountType.id}
                        className={`${classes.tableRow}`}
                      >
                        <TableCell className={classes.tCell}>
                          <Node nodeId={accountType.id} isLink size="xs" node={accountType} />
                        </TableCell>
                        <TableCell className={classes.tCell}>
                          {allAccsByAccType.length ?
                            <div
                              onClick={(e) => this.statusFilterChange('all', accountType.id, !allSelected )}
                              className={`${classes.actionIcon} ${allSelected ? 'selected' : ''}`}
                            >
                              {allAccsByAccType.length}
                            </div>
                          : null}
                        </TableCell>
                        
                        <TableCell
                          className={classes.tCell}
                        >
                          {activeAccs.length ?
                            <div
                              onClick={(e) => this.statusFilterChange('active', accountType.id, !activeSelected )}
                              className={`${classes.actionIcon} ${activeSelected ? 'selected' : ''}`}
                              style={{ color: activeAcc }}
                            >
                              {activeAccs.length}
                            </div>
                          : null}
                        </TableCell>
                        <TableCell
                          className={`${classes.tCell}`}
                        >
                          {inactiveAccs.length ?
                            <div
                              onClick={(e) => this.statusFilterChange('inactive', accountType.id, !inactiveSelected )}
                              className={`${classes.actionIcon} ${inactiveSelected ? 'selected' : ''}`}
                              style={{ color: inactiveAcc }}
                            >
                              {inactiveAccs.length}
                            </div>
                          : null}
                        </TableCell>
                      </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              : null}

              <Table
                className={`${classes.table} ${classes.ml30}`}
                style={{ width: 'min-content', height: 'fit-content' }}
              >
                {/* <TableHead>
                  <TableRow>
                    <TableCell className={`${classes.columnHeadingGeneral} ${classes.tableCell}`}>ID</TableCell>
                    <TableCell className={classes.columnHeadingGeneral}>Login</TableCell>
                    <TableCell className={classes.columnHeadingGeneral}>Type</TableCell>
                    <TableCell className={classes.columnHeadingGeneral}>Individual</TableCell>
                    <TableCell className={classes.columnHeadingGeneral}>Groups</TableCell>
                  </TableRow>
                </TableHead> */}

                <TableBody>
                  <InfiniteScroll
                    dataLength={items}
                    next={this.fetchMoreData}
                    hasMore={hasMoreData}
                    loader={
                      accs && accs.length &&
                      <div className={classes.loaderContainer}>
                        <LoaderNew />
                      </div>
                    }
                    scrollableTarget='accs-list'
                    style={{
                      overflow: 'hidden',
                    }}
                  >{accsChunk && accsChunk.length && accsChunk.map((account) => {
                    return (
                      <AccountRow
                        key={account.id}
                        classes={classes}
                        account={account}
                        accountsTbox={accountsTbox}
                        onAccountTypeChange={this.onAccountTypeChange}
                        accStatusColor={account.access_level === -1 ? inactiveAcc : activeAcc}
                      />
                    )})}
                  </InfiniteScroll>
                </TableBody>
              </Table>
            </div>
            ) : loaded && currentTab === PRIVATE ? (
              <PersonalInviteTab
                classes={classes}
                nodesData={nodesData}
                setup_accounts={accounts}
                onEnableInvite={this.onEnableInvite}
                deleteInvitation={this.deleteInvitation}
                addNodeToNodesData={this.addNodeToNodesData}
                sendInvitation={this.sendInvitation}
                accountsTbox={accountsTbox}
                createInvite={this.createInvite}
                privateInvites={privateInvites}
                allSetupAccounts={allSetupAccounts}
              >
              </PersonalInviteTab>
            ) : loaded && currentTab === PUBLIC ? (
              <PublicInviteTab
                classes={classes}
                onEnableInvite={this.onEnableInvite}
                deleteInvitation={this.deleteInvitation}
                setupAncestors={setupAncestors}
                accountsTbox={accountsTbox}
                createInvite={this.createInvite}
                publicInvites={publicInvites}
                allSetupAccounts={allSetupAccounts}
                >
              </PublicInviteTab>
            ) : (
            <div className={classes.loaderContainer}>
              <LoaderNew />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  setup: state.meta.setup,
  light_meta_and_ops: state.meta.light_meta_and_ops,
}),
{})(withStyles(styles)(AccountsPage));
